/** @format */
import { Link } from 'react-router-dom';
import { useContext } from 'react';

import Logo from '../Assets/Images/logo.svg';
import { useAuth } from '../Hooks/Auth';
import { Context } from '../Context/Context';
import User from '../Assets/Images/user 1.png';
import { useRole } from '../Hooks/Role';

const Header = ({ headerFixed }) => {
  const { check, logout } = useAuth();
  const { can, canBoard } = useRole();
  const context = useContext(Context);

  const openProfileMenu = () => {
    let backDark = document.getElementById('dark-back');
    let profileMenu = document.getElementById('header-menu-profile');

    backDark.classList.remove('d-none');
    backDark.classList.add('d-flex');
    profileMenu.classList.remove('d-none');
    profileMenu.classList.add('d-flex');
  };
  const closeProfileMenu = () => {
    let backDark = document.getElementById('dark-back');
    let profileMenu = document.getElementById('header-menu-profile');

    profileMenu.classList.add('d-none');
    profileMenu.classList.remove('d-flex');
    backDark.classList.add('d-none');
    backDark.classList.remove('d-flex');
  };

  return (
    <header className={`w-100 ${headerFixed ? 'sticky-top' : ''}`}>
      <section className='container-fluid '>
        <div className='row'>
          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
            <Link
              to={can('Super Admin') || canBoard() ? '/' : '/gym/list'}
              className='w-30 d-none d-sm-none d-md-flex d-lg-flex d-xl-flex flex-row justify-content-start'
            >
              <img src={Logo} alt='logo' className='mt-2 w-100' />
            </Link>
            <Link
              to={can('Super Admin') || canBoard() ? '/' : '/gym/list'}
              className='d-flex d-sm-flex d-md-none h-100 d-lg-none d-xl-none flex-row justify-content-start'
            >
              <img src={Logo} alt='logo' className='mt-2 w-100' />
            </Link>
          </div>
          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 justify-content-center align-items-center mt-3 text-center'>
            <span className='f-14 font-weight-bold text-center text-break mt-3'>
              سامانه مسابقات فدراسیون زورخانه ای
            </span>
          </div>
        </div>
      </section>
      <div className='w-100 bg-purple py-1 mt-2'>
        <section className='container-fluid'>
          <div className='row'>
            <div className='col-12 col-md-8'>
              <div className='d-flex flex-row'>
                <ul className='d-flex flex-row nav mt-2'>
                  <li className=''>
                    <Link
                      className='text-dark-mode f-14 mx-2'
                      to={can('Super Admin') || canBoard() ? '/' : '/gym/list'}
                    >
                      صفحه اصلی
                    </Link>
                  </li>
                  <li className=''>
                    <a
                      href='https://portal.izpf.ir'
                      className='text-dark-mode f-14 mx-2'
                    >
                      سامانه آموزش
                    </a>
                  </li>
                  <li className=''>
                    <Link className='text-dark-mode f-14 mx-2' to='/gym/list'>
                      لیست زورخانه ها
                    </Link>
                  </li>
                  <li className=''>
                    <Link className='text-dark-mode f-14 mx-2' to='/gym/create'>
                      ثبت زورخانه
                    </Link>
                  </li>
                  {can('Super Admin') && (
                    <li className=''>
                      <Link
                        className='text-dark-mode f-14 mx-2'
                        to='/rank/print'
                      >
                        چاپ حکم
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className='col-12 col-md-4'>
              <div className='w-100 d-none d-sm-none d-md-flex d-lg-flex d-xl-flex'>
                {check() ? (
                  <>
                    <div className='d-flex flex-row  w-100 c-pointer'>
                      <div
                        className='w-100 d-flex flex-row justify-content-end c-pointer'
                        onClick={openProfileMenu}
                      >
                        <img
                          style={{
                            width: '40px',
                            height: '40px',
                          }}
                          src={
                            context?.user?.personnel_image == null ||
                            context?.user?.personnel_image === undefined
                              ? User
                              : context?.user?.personnel_image
                          }
                          alt='user'
                          className='img-thumbnail rounded-circle rounded-pill'
                        />
                        <i className='far fa-angle-down f-24 text-white mx-3 align-self-center'></i>
                      </div>

                      <div
                        onClick={closeProfileMenu}
                        className='d-none vw-100 vh-100'
                        id='dark-back'
                        style={{
                          position: 'fixed',
                          zIndex: '99',
                          top: '0',
                          right: '0',
                        }}
                      ></div>
                      <div
                        id='header-menu-profile'
                        className='d-none flex-column bg-sky-light  rounded shadow p-2 position-absolute'
                        style={{
                          width: '246px',
                          top: '44px',
                          left: '15px',
                          zIndex: '9999999',
                          opacity: '.9',
                        }}
                      >
                        <div className='d-flex flex-row border-bottom border-secondary text-center justify-content-start pb-2 p-2'>
                          <div
                            className='w-100 d-flex flex-row justify-content-start c-pointer'
                            onClick={openProfileMenu}
                          >
                            <img
                              style={{
                                width: '40px',
                                height: '40px',
                              }}
                              src={
                                context?.user?.personnel_image == null ||
                                context?.user?.personnel_image === undefined
                                  ? User
                                  : context?.user?.personnel_image
                              }
                              alt='user'
                              className='img-thumbnail rounded-circle rounded-pill'
                            />
                            <div className='d-flex flex-column'>
                              <span className='text-dark f-13 mx-2'>
                                {context?.user?.name} {context?.user?.last_name}
                              </span>
                              <span className='text-secondary f-10 mt-1 mx-2'>
                                {context?.user?.national_card_id}
                              </span>
                            </div>
                          </div>
                        </div>
                        <ul className='d-flex flex-column nav m-0 p-0'>
                          <li className='d-flex border-bottom border-secondary my-1'>
                            <Link
                              to={
                                can('Super Admin') || canBoard()
                                  ? '/'
                                  : '/gym/list'
                              }
                              className='w-100 d-flex flex-row py-2'
                            >
                              <i className='far fa-user text-dark f-18'></i>
                              <span className='text-dark f-12 mx-2'>
                                صفحه اصلی
                              </span>
                            </Link>
                          </li>

                          <li className='d-flex my-1 border-bottom border-secondary'>
                            <Link
                              to='/dashboard'
                              className='w-100 d-flex flex-row py-2'
                            >
                              <i className='far fa-user-cog text-dark f-18'></i>
                              <span className='text-dark f-12 mx-2'>
                                ورود به سامانه
                              </span>
                            </Link>
                          </li>

                          <li className='d-flex my-1'>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                logout();
                              }}
                              to='#'
                              className='w-100 d-flex flex-row py-2'
                            >
                              <i className='far fa-door-open text-dark f-18'></i>
                              <span className='text-dark f-12 mx-2'>خروج</span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className='w-100 d-flex flex-column justify-content-end align-items-center'>
                    <Link
                      to='/dashboard'
                      className='w-100 d-flex flex-row justify-content-end'
                    >
                      <span className='text-white mx-2 f-13 mt-1 font-weight-bold'>
                        ورود به سامانه
                      </span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </header>
  );
};
export default Header;
